import React, { useContext } from 'react';
import parse from 'html-react-parser';
import { endsWith, isEmpty } from 'lodash';
import { DWTCContext } from '../utils/context';
import { getTranslationByKey } from '../helpers/translation-helper';
import {
  SectionBreadCrumb,
  // SectionHead,
  DownloadWrapper,
  DownloadLabel,
  DownloadSize,
  PdfIcon,
} from './styles/FreeZoneServiceBreadcrumbBlock.styled';
import { Container } from './styles/Container.styled';
import { Row } from './styles/Row.styled';
import { ColumnMdEightSmTwelve, ColumnButtonFour } from './styles/Column.styled';
import { ButtonDiv, Button } from './styles/Button.styled';

export default function CalloutMessage({ data, dir }) {
  const [filesize, setFilesize] = React.useState('(0 KB)');
  const { translations, cssClass } = useContext(DWTCContext);

  React.useEffect(() => {
    if (!isEmpty(data.link)) {
      const getFilesize = () =>
        new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.open('GET', data.link.url, true);
          xhr.onprogress = (event) => {
            if (event.lengthComputable) {
              resolve(event.total);
            } else {
              reject(new Error('No content-length available'));
            }
            xhr.abort();
          };
          xhr.send();
        });
      getFilesize()
        .then((size) => setFilesize(`(${(+size / 1024).toFixed(2)} KB)`))
        .catch(() => setFilesize('(0 KB)'));
    }
  }, []);

  const isFile = (link) => link && endsWith(link.url, '.pdf');

  const handleDataLink = (link) => {
    if (isEmpty(link)) return null;
    if (endsWith(link.url, '.pdf')) {
      return (
        <DownloadWrapper>
          <PdfIcon />
          <DownloadLabel href={link.url} target={link.target} dir={dir}>
            {getTranslationByKey(translations, 'Download')}
          </DownloadLabel>
          <DownloadSize dir={dir}>{filesize}</DownloadSize>
        </DownloadWrapper>
      );
    }
    return (
      <Button stylevariant="red" href={data.link.url} target="_self" rel="" dir={dir}>
        {data.link.name}
      </Button>
    );
  };

  return (
    <SectionBreadCrumb
      id="calloutMessage"
      dir={dir}
      className={isFile(data.link) && 'download-file'}
    >
      <Container className={cssClass}>
        {data.link ? (
          <Row>
            <ColumnMdEightSmTwelve className="download_title" dir={dir}>
              {parse(data.text)}
            </ColumnMdEightSmTwelve>
            <ColumnButtonFour className={isFile(data.link) && 'download-filebtn'}>
              <ButtonDiv className="btn_breadcrumn" dir={dir}>
                {handleDataLink(data.link)}
              </ButtonDiv>
            </ColumnButtonFour>
          </Row>
        ) : (
          <div className="download_title" dir={dir}>
            {parse(data.text)}
          </div>
        )}
      </Container>
    </SectionBreadCrumb>
  );
}
